import { ValidationResult } from "./validation-result";

export interface CustomQualification {
    id: number;
    question: string;
    description: string;
    activeStatus: string;
    agencyId: number;
    required: number;
    controlType: string;
}

export class CustomQualification {
    constructor() {
        this.id = 0;
        this.question = '';
        this.description = '';
        this.activeStatus = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.question.length < 4) {
            vr.focus_field = 'question';
            vr.error = 'Error: A question is required (must be at least 4 characters)';
            return vr;
        }

        return vr;
    }
}